export const enum ProvidersUsersMutationsNames {
    SetScopedUsersList = "setScopedUsers",
    SetScopedCPUsersList = "setScopedCPUsers",
    SetUnscopedUsersList  = "setUnscopedUsers",
    SetSelected = "setSelectedProvidersUser",
    SetUnscopedUsersError = "setUnscopedUsersError",
    SetScopedUsersError = "setScopedUsersError",
    ResetState = "resetState",
}

export const enum ProvidersUsersActionsNames {
    FetchScopedUsersList = "fetchScopedUsersList",
    FetchScopedCPUsersList = "fetchScopedCPUsersList",
    FetchUnscopedUsersList = "fetchUnscopedUsersList",
    SetSelected = "setSelectedProvidersUser",
    ResetState = "resetProvidersUserState",
}

export const enum ProvidersUsersGettersNames {
    ScopedUsersList = "scopedUsersList",
    UnscopedUsersList = "unscopedUsersList",
    ScopedCPUsersList = "scopedCPUsersList",
    Selected = "selectedProvidersUser",
    IsSelected = "isSelectedProvidersUser",
}
